import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { site } from '../config';
import { navLinks } from '../data';
import CallButton from './CallButton';
import ChatButton from './ChatButton';
import Icon from './Icon';

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header className="header">
      <div className="strip">
        <div className="wrap strip-row">
          <span>
            <Icon name="clock" size={14} /> {site.hours}
          </span>
          <a href={site.phoneHref}>Call {site.phone}</a>
        </div>
      </div>

      <div className="wrap header-row">
        <Link to="/" className="logo">
          <span className="logo-mark">
            <Icon name="leaf" size={20} />
          </span>
          <span className="logo-text">
            <strong>{site.brand}</strong>
            <small>{site.domain}</small>
          </span>
        </Link>

        <nav className="nav" aria-label="Main navigation">
          {navLinks.map((link) => (
            <NavLink key={link.to} to={link.to} end className="nav-link">
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="header-cta">
          <CallButton size="sm" />
          <ChatButton size="sm">Chat Now</ChatButton>
        </div>

        <button
          type="button"
          className="menu-btn"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {open && (
        <nav className="drawer" aria-label="Mobile navigation">
          {navLinks.map((link) => (
            <NavLink key={link.to} to={link.to} end className="drawer-link">
              {link.label}
            </NavLink>
          ))}
          <CallButton block />
          <ChatButton block />
        </nav>
      )}
    </header>
  );
}
